import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub,
  faLinkedin,
  // faSkype,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';

class Header extends Component {
  render() {
    return (
      <header id="home">
        <nav id="nav-wrap">

          <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
          <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

          <ul id="nav" className="nav">
            <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
            {/*<li><a className="smoothscroll" href="#resume">Resume</a></li>*/}
            {/*<li><a className="smoothscroll" href="#portfolio">Works</a></li>*/}
            <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
            {/*<li><a className="smoothscroll" href="#about">About</a></li>*/}
            <li><a className="smoothscroll" href="#contact">Contact</a></li>
          </ul>

        </nav>

        <div className="row banner">
          <div className="banner-text">
            <img width="600" alt="main-logo" src="./images/logo.png" />
            <h3>
              An IT enthusiast, love to travel and explore some new things around.
            </h3>
            <hr />
            <ul className="social">
              <li><a href="http://github.com/yusufinthehouse" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faGithub} /></a></li>
              <li><a href="https://www.linkedin.com/in/myusufmaulana" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faLinkedin} /></a></li>
              <li><a href="https://wa.me/6281220575075" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faWhatsapp} /></a></li>
              <li><a href="mailto:mail@yusuf-maulana.com" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faEnvelope} /></a></li>
              {/*<li><a href="skype:yusufinthehouse?call" rel="noopener noreferrer" target="_blank"><FontAwesomeIcon icon={faSkype} /></a></li>*/}
            </ul>
          </div>
        </div>

        <p className="scrolldown">
          <a className="smoothscroll" href="#about"><i className="icon-down-circle"></i></a>
        </p>

      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js